import $$api from 'models/api';
import $$auth from 'models/auth';
import { z } from 'zod';

import ModalsService from './ModalsService';

import env from 'constants/env';

import ApiFactory from 'api';

import AlertsService from 'services/AlertsService';

const MarketingSiteService = {
    api: ApiFactory,
    alerts: AlertsService,
    sendEmployeeEmail: async (email: string) => {
        try {
            const validEmail = z.string().email().parse(email);
            await $$api.employer.sendCodeFx(validEmail);
        } catch (error) {
            AlertsService.handleError(error);
        }
    },
    openPreSignupModal: () => {
        const isLoggedIn = $$auth.$currentParticipant.map(Boolean).getState();
        const isAdvisor = $$auth.$systemRoles.getState().includes('advisor');
        if (!isLoggedIn) {
            window.location.href = `${env.REACT_APP_APPLICATION_URL}/signup?role=advisor`;
        } else {
            if (isAdvisor) {
                window.location.href = `${env.REACT_APP_APPLICATION_URL}/advisor`;
            } else {
                ModalsService.showModality(
                    'Advisor Account Alert',
                    'You are about to initiate an advisor account creation. If you do not wish to create an advisor account, click "Back to Dashboard" to go back to your Estate Plan.',
                    {
                        confirmButton: 'Proceed',
                        closeButton: 'Back to Dashboard',
                        onConfirm: () => {
                            window.location.href = `${env.REACT_APP_APPLICATION_URL}/advisor`;
                        },
                        onCancel: () => {
                            window.location.href = `${env.REACT_APP_APPLICATION_URL}/dashboard`;
                        },
                    },
                );
            }
        }
    },
};

declare global {
    interface Window {
        myadvocate: typeof MarketingSiteService;
    }
}

window.myadvocate = MarketingSiteService;

export default MarketingSiteService;
